export interface LeadQuestionAnswerPair {
  question: string;
  questionText: string;
  answer: string;
  category: string;
}

export const getCategoryForQuestion = (questionKey: string): string => {
  const normalizedKey = questionKey.toLowerCase();

  if (normalizedKey.includes("marketing") || normalizedKey.includes("campaign")) {
    return "Marketing";
  }

  if (normalizedKey.includes("sales") || normalizedKey.includes("crm")) {
    return "Sales & CRM";
  }

  if (normalizedKey.includes("website") || normalizedKey.includes("seo")) {
    return "Website";
  }

  if (normalizedKey.includes("operations") || normalizedKey.includes("process")) {
    return "Operations";
  }

  return "General";
};

export const mapQuestionsAndAnswers = (
  questions: Record<string, unknown> | undefined,
  answers: Record<string, string> | undefined
): LeadQuestionAnswerPair[] => {
  const questionEntries = Object.entries(questions ?? {});

  if (questionEntries.length === 0) {
    return Object.entries(answers ?? {}).map(([key, value]) => ({
      question: key,
      questionText: key,
      answer: value || "N/A",
      category: getCategoryForQuestion(key),
    }));
  }

  return questionEntries.map(([key, value]) => ({
    question: key,
    questionText: typeof value === "string" ? value : String(value ?? key),
    answer: answers?.[key] || "N/A",
    category: getCategoryForQuestion(key),
  }));
};
